/**
 * Copyright 2024-2025 Wingify Software Pvt. Ltd.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import messages from 'vwo-fme-sdk-log-messages';

const resolvedMessages: Record<string, any> =
  (messages as unknown as { default?: Record<string, any> }).default || (messages as Record<string, any>);

const DebugLogMessagesEnum = resolvedMessages.debugMessages;
const InfoLogMessagesEnum = resolvedMessages.infoMessages;
const ErrorLogMessagesEnum = resolvedMessages.errorMessagesV2;

export { DebugLogMessagesEnum, InfoLogMessagesEnum, ErrorLogMessagesEnum };
